import { render } from "./TeacherDashboard.vue?vue&type=template&id=680fe17e"
import script from "./TeacherDashboard.vue?vue&type=script&lang=js"
export * from "./TeacherDashboard.vue?vue&type=script&lang=js"

import "./TeacherDashboard.vue?vue&type=style&index=0&id=680fe17e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__